import React from 'react';

export type result = {
    cost: number;
    market: number;
    urgency: number;
    mandatory: number;
    frequency: number;
    popularity: number;
}


export type idea = {
    name: string;
    pitch: string;
    description: string;
    results: result[];
    score: number;
    url?: string;
    views?: number;
}



/** @constant DEFAULT_TEXT_SIZE: used to scale down reply's text from comments and post's. */
const DEFAULT_TEXT_SIZE = 5


export type color = 'white' | 'black' | 'light' 
    | 'dark' | 'primary' | 'link' | 'info' 
    | 'success' | 'warning' | 'danger'


interface iText { 
    content: any;
    size?: number;
    isTitle?: boolean;
    isSubtitile?: boolean;
    alignment?: 'left' | 'centered' | 'right' | 'justified';
    color?: color;
};



/** @atom Text. */
export const Text = ({ 
    content, 
    size, 
    isTitle = false, 
    isSubtitile = false,
    alignment = 'left',
    color = 'dark'
}: iText) => {
    const textType = () => {
        if(isTitle) return 'title is'
        if(isSubtitile) return 'subtitle is'
        return 'is-size'
    }

    const sizeMap = (): number => {
        if(size) return size
        if(isTitle) return 3
        if(isSubtitile) return 5
        return DEFAULT_TEXT_SIZE
    }

    const className = `${textType()}-${sizeMap()} has-text-${color} has-text-${alignment}`
    return <p className={className} > { content } </p>
}


export const setScoreColor = (score: number): color => {
    if (score > 80) return 'danger'
    if (score > 50) return 'success'
    if (score > 20) return 'primary'
    return 'warning'
}


export type option = { text: string, value: any }
export interface iResultAttribute {
    label: string;
    text: string;
    options: option[]
}

export const POPULARITY = {
    label: 'How many users would this product have?',
    text: 'Potential Users: ',
    options: [
        {value: 0, text:'0'}, 
        {value: 1, text:'1'}, 
        {value: 10, text:'10'}, 
        {value: 100, text:'100'}, 
        {value: 1000, text:'1K'}, 
        {value: 10*1000, text:'10K'}, 
        {value: 100*1000, text:'100K'}, 
        {value: 1000*1000, text:'1M'}, 
        {value: 10*1000*1000, text:'10M'}, 
        {value: 100*1000*1000, text:'100M'}, 
        {value: 1000*1000*1000, text:'1B'}
    ]
}

export const MARKET_GROWTH = {
    label: 'How much is this market/industry growing?',
    text: 'Yearly Market Growth: ',
    options: [
        {value: 0, text:'0%'}, 
        {value: 10, text:'10%'},
        {value: 20, text:'20%'},
        {value: 50, text:'50%'},
        {value: 100, text:'100%'},
        {value: 500, text:'500%'},
        {value: 1000, text:'1,000%'}
    ]
}

export const PRODUCT_COST = {
    label: 'What is the lifetime value of the solution per user?',
    text: 'Average Cost per user: ',
    options: [
        {value: 0, text: '$0'},
        {value: 1, text: '$1'},
        {value: 10, text: '$10'},
        {value: 20, text: '$20'},
        {value: 50, text: '$50'},
        {value: 100, text: '$100'},
        {value: 500, text: '$500'},
        {value: 1000, text: '$1,000'},
        {value: 10*1000, text: '$10,000'},
        {value: 100*1000, text: '+$10,000'},
    ]
}


export const PROBLEM_FREQUENCY = {
    label: 'How often would users engage with this product?',
    text: 'Engagement Frequency: ',
    options: [
        {value: 1, text: 'Once'},
        {value: 10, text: 'Yearly'},
        {value: 12*10, text: 'Monthly'},
        {value: 50*10, text: 'Weekly'},
        {value: 365*10, text: 'Daily'},
        {value: 24*365*10, text: 'Hourly'},
    ]
}

export const URGENCY = {
    label: 'Does this idea solves a an urgent problem?',
    text: 'Is it Urgent to implement: ',
    options: [
        {value: 0, text:'No'},
        {value: 1, text:'Yes'}
    ]
}

export const MANDATORY = {
    label: 'Is it mandatory to find a solution to this problem?',
    text: 'Is it ̣Mandatory to implement: ',
    options: [
        {value: 0, text:'No'},
        {value: 1, text:'Yes'}
    ]
}
